<template>
  <div class="row mx-1">
    <div class="col-20">
      <div class="row mt-2 mb-4">
        <div
          v-for="item in statusFilterOptions"
          :key="item.status"
          class="col-20 col-sm-6 col-lg-4 mb-2 mb-lg-0"
        >
          <filter-option
            :title="$t(`payment.status.${item.status}`)"
            :icon="item.icon"
            :active="filters.status == item.status"
            add-class="option text-capitalize"
            @click="setStatusFilter(item.status)"
          />
        </div>
      </div>
    </div>
    <div class="col-20">
      <div class="row">
        <div class="col-20 col-md-10 col-lg-5 mb-1 mb-lg-0">
          <label for="payment-id">{{ $t('view-Payments.filters.label.payment_id') }}</label>
          <b-form-input
            id="payment-id"
            v-model="filters.id"
            type="text"
            :placeholder="$t('view-Payments.filters.placeholder.payment_id')"
          />
        </div>
        <div class="col-20 col-md-10 col-lg-5 mb-1 mb-lg-0">
          <label for="payment-date">{{ $t('view-Payments.filters.label.date') }}</label>
          <b-form-input
            id="payment-date"
            v-model="filters.date"
            type="date"
            :class="!filters.date || filters.date === '' ? 'empty' : ''"
          />
        </div>
        <div class="col-20 col-md-10 col-lg-5 mb-1 mb-lg-0">
          <label for="payment-campaign-name">{{ $t('view-Payments.filters.label.campaign_name') }}</label>
          <b-form-input
            id="payment-campaign-name"
            v-model="filters.campaign_name"
            type="text"
            :placeholder="$t('view-Payments.filters.placeholder.campaign_name')"
          />
        </div>
        <div
          v-if="!isAdvertiser"
          class="col-20 col-md-10 col-lg-5 mb-1 mb-lg-0"
        >
          <label for="payment-brand">{{ $t('view-Payments.filters.label.advertiser_name') }}</label>
          <b-form-input
            id="payment-brand"
            v-model="filters.advertiser_name"
            type="text"
            :placeholder="$t('view-Payments.filters.placeholder.advertiser_name')"
          />
        </div>
        <div
          v-else
          class="col-20 col-md-10 col-lg-5 mb-1 mb-lg-0"
        >
          <label for="payment-brand">{{ $t('view-Payments.filters.label.influencer_name') }}</label>
          <b-form-input
            id="payment-brand"
            v-model="filters.influencer_name"
            type="text"
            :placeholder="$t('view-Payments.filters.placeholder.influencer_name')"
          />
        </div>
      </div>
    </div>
    <div class="col-20 text-right mt-4 pt-1 mb-2">
      <btn-with-icon
        :icon="$publicPath + 'img/payments/x.svg'"
        :title="$t('view-Payments.filters.button.clear')"
        :white-version="true"
        @click="clearFilters"
      />
    </div>
  </div>
</template>

<script>
import BtnWithIcon from '../../components/buttons/BtnWithIcon'
import FilterOption from '../search-partials/FilterOption'

export default {
  components: {
    'btn-with-icon': BtnWithIcon,
    'filter-option': FilterOption
  },
  data () {
    return {
      filters: {
        status: 'all'
      },
      buttonLoader: false
    }
  },
  computed: {
    isAdvertiser () {
      return this.$store.state.user.profile.type === 'advertiser'
    },
    statusFilterOptions () {
      const list = [
        {
          status: 'new',
          icon: `${this.$publicPath}img/payments/add.svg`
        },
        {
          status: 'in_progress',
          icon: `${this.$publicPath}img/payments/infinity.png`
        },
        {
          status: 'rejected',
          icon: `${this.$publicPath}img/payments/x.svg`
        },
        {
          status: 'completed',
          icon: `${this.$publicPath}img/payments/ok.svg`
        },
        {
          status: 'all',
          icon: `${this.$publicPath}img/payments/tiles.svg`
        }
      ]

      return list
    }
  },
  watch: {
    filters: {
      handler: function (val, oldVal) {
        this.$emit('change', this.filters)
      },
      deep: true
    }
  },
  methods: {
    setStatusFilter (status) {
      this.filters.status = status
    },
    clearFilters () {
      this.filters = {
        status: 'all'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  input {
    border: 2px solid $nh-gray;
  }
  input.empty {
    color: #D3D1D1;
  }
  .option {
    width: 100%;
    margin-right: 0;
    &:hover {
      border-color: $warning;
    }
    &.active {
      background-color: $warning;
    }
  }
</style>
